// 액션 타입을 정의
const SET_MODAL_STATE = 'modal/SET_MODAL_STATE' as const;
const SET_CONFIRM_TEXT = 'modal/SET_CONFIRM_TEXT' as const;
const SET_ALERT_TEXT = 'modal/SET_ALERT_TEXT' as const;
const SET_CALLBACK = 'modal/SET_CALLBACK' as const;

export interface CallBackFunction {
  (): void;
}

/** Modal Reducer State Type */
export interface Modal {
  modalState: ModalState;
  confirmText: string; //정말 삭제하시겠습니까? 등 확인텍스트
  alertText: string; //삭제되었습니다, 에러가 발생했습니다 등 알림텍스트
  callBack: CallBackFunction | null;
}

/** Modal Reducer ProcessState Enum Type */
export enum ModalState {
  /** 동작하지 않는 상태. redux의 state가 초기인, 혹은 초기화된 상태. */
  PROCESS_IDLE = 'PROCESS_IDLE',

  /** 프로세스 완료 혹은 취소상태. 이 경우 useModalProcess에서 state값을 초기화한 후 modalState역시 process idle로 바꿔줌 */
  PROCESS_DONE = 'PROCESS_DONE',

  /** 확인대기상태, 즉 확인모달이 띄워진(띄워져야하는) 상태 */
  CONFIRM_AWAIT = 'CONFIRM_AWAIT',

  /** 확인모달 - 확인버튼 클릭한 상태. callBack함수(보통 api) 실행하게되는 상태  */
  CONFIRM_ALLOW = 'CONFIRM_ALLOW',

  /** 알림모달이 띄워진(띄워져야하는) 상태 */
  ALLERT_NOW = 'ALLERT_NOW', //프로세스 진행 이후 / 혹은 단순 알림용 모달 띄우는 상태
}

// 액션 생성 함수
/** 모달프로세스 state 변경. enum 사용 */
export const setModalState = (item: ModalState) => ({
  type: SET_MODAL_STATE,
  payload: item,
});

/** 정말 삭제하시겠습니까? 등 확인텍스트 */
export const setConfirmText = (item: string) => ({
  type: SET_CONFIRM_TEXT,
  payload: item,
});

/** 삭제되었습니다, 실패하였습니다 등 알림텍스트 */
export const setAlertText = (item: string) => ({
  type: SET_ALERT_TEXT,
  payload: item,
});

/** 확인모달 - 확인 클릭시 실행될 콜백함수. */
export const setCallBack = (item: CallBackFunction | null) => ({
  type: SET_CALLBACK,
  payload: item,
});

/** 초기상태 정의 */
export const initialState: Modal = {
  modalState: ModalState.PROCESS_IDLE,
  confirmText: '',
  alertText: '',
  callBack: null,
};

/** 액션타입 정의 */
type ModalAction =
  | { type: typeof SET_MODAL_STATE; payload: ModalState }
  | { type: typeof SET_CONFIRM_TEXT; payload: string }
  | { type: typeof SET_ALERT_TEXT; payload: string }
  | { type: typeof SET_CALLBACK; payload: CallBackFunction };

const modalReducer = (
  state: Modal = initialState,
  action: ModalAction
): Modal => {
  switch (action.type) {
    case SET_MODAL_STATE:
      return { ...state, modalState: action.payload };
    case SET_CONFIRM_TEXT:
      return { ...state, confirmText: action.payload };
    case SET_ALERT_TEXT:
      return { ...state, alertText: action.payload };
    case SET_CALLBACK:
      return { ...state, callBack: action.payload };
    default:
      return state;
  }
};

export default modalReducer;
